import React from 'react'
import { Layout } from 'antd'
const { Footer } = Layout

export default function BottomFooter() {
  return (
    <Footer style={{ textAlign: 'right'}}><a href="https://beian.miit.gov.cn">粤ICP备2020075652号</a></Footer>
  )
}
